module.exports = __webpack_public_path__ + "img/1.a21319d9.png";